import { useState } from "react";
import styled from "styled-components";

const faqs = [
  {
    q: "1. What is the IIT Madras Technology Summit & Awards?",
    a: "It is a flagship event by IIT Madras that brings together industry leaders, policymakers, innovators, and academia to discuss, showcase, and recognise technology-led innovation and impact."
  },
  {
    q: "2. Who can attend the Summit?",
    a: `
    <p>The Summit is open to a diverse group of stakeholders committed to driving impact, including:</p>
    <ul>
      <li>Corporate leaders and CXOs</li>
      <li>CSR, ESG, and sustainability professionals</li>
      <li>Technology and innovation heads</li>
      <li>Startup founders and entrepreneurs</li>
      <li>Policymakers and government officials</li>
      <li>Researchers and faculty</li>
      <li>Impact-focused organisations</li>
    </ul>
  `
  },
  {
    q: "3. How can organisations participate?",
    a: "Organisations can participate as delegates or award applicants."
  },
  {
    q: "4. Where will the event be held?",
    a: "The Summit will be hosted at Bharat Mandapam, New Delhi."
  },
  {
    q: "5. How can I apply for the IIT Madras Social Impact Award 2026?",
    a: "To apply, please complete the online nomination form available on this website. Ensure that all required details and supporting documents are submitted before the specified deadline. Only completed applications received within the timeline will be considered for evaluation."
  },
    {
    q: "6. Is there a participation fee for attending the Summit?",
    a: "Details regarding delegate registration, participation categories, and any applicable fees will be shared on the registration page of this website."
  },
    {
    q: "7. What kind of projects are eligible for the Social Impact Awards?",
    a: "Projects that leverage technology to address societal challenges and are supported through CSR or philanthropic funding are eligible for consideration."
  },

  {
    q: "8. Can organisations partner with IIT Madras through the Summit?",
    a: "Yes. The Summit provides opportunities to explore research collaborations, CSR partnerships, translational technology deployment, and long-term strategic engagement with IIT Madras."
  },
  {
    q: "9. Will there be networking opportunities during the Summit?",
    a: "Yes. The Summit includes curated networking sessions, leadership interactions, and showcase segments designed to facilitate meaningful conversations and partnerships."
  },
  {
    q: "10. How are award applications evaluated?",
    a: "Applications are reviewed by an expert panel based on criteria such as innovation, scalability, inclusiveness, measurable impact, and alignment with national priorities."
  },
  {
    q: "11. Can startups participate in the Summit?",
    a: "Yes. The Summit includes technology and startup showcases and welcomes founders working on innovation-led solutions aligned with national development priorities."
  },
  {
    q: "12. How can I stay updated about announcements and deadlines?",
    a: "All updates regarding registration, award timelines, speaker announcements, and agenda details will be published on this website."
  },

];

export default function FAQSection() {
  const [open, setOpen] = useState(null);

  return (
    <Section id="faqs">
      <Container>
      <Heading>IIT Madras Technology Summit & Awards 2026</Heading>
        <HeadingFAQ>Frequently Asked Questions (FAQs)</HeadingFAQ>

        <List>
          {faqs.map((item, i) => (
            <Item key={i} active={open === i}>
              
              <Question onClick={() => setOpen(open === i ? null : i)}>
                {item.q}
                <Icon active={open === i}>⌄</Icon>
              </Question>

              <Answer
                active={open === i}
                dangerouslySetInnerHTML={{ __html: item.a }}
              />

            </Item>
          ))}
        </List>

      </Container>
    </Section>
  );
}

const Section = styled.section`
  padding: 20px 20px;
  background: linear-gradient(135deg,#f8fbff,#eef5ff);
  scroll-margin-top: 100px;

  @media (max-width: 768px) {
    padding: 10px 4px;
    scroll-margin-top: 100px;
  }
`;

const Container = styled.div`
  max-width: 1000px;
  margin:auto;
  margin-top: 10px;
`;

const Heading = styled.h2`
  text-align:center;
  font-size: 38px;
  font-weight:700;
  color:#791e1b;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 2px;
  }
`;

const List = styled.div`
  display:flex;
  flex-direction:column;
  gap: 8px;

  @media (max-width: 768px) {
    gap: 6px;
  }
`;

const Item = styled.div`
  border-radius: 16px;
  background: rgba(255,255,255,0.75);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.08);
  overflow: hidden;
  transition: .3s;

  &:hover{
    transform:translateY(-2px);
    box-shadow:0 15px 35px rgba(0,0,0,0.12);
  }
`;

const Question = styled.div`
  padding: 12px 26px;
  font-size:18px;
  font-weight:600;
  color:#102a43;
  cursor:pointer;
  display:flex;
  justify-content:space-between;
  align-items:center;

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 8px 6px;
  }
`;

const Icon = styled.span`
  font-size: 20px;
  transition:.3s;
  transform:${p=>p.active ? "rotate(180deg)" : "rotate(0)"};
  color:#4c7cff;  
`;

const Answer = styled.div`
  max-height:${p=>p.active ? "400px" : "0"};
  opacity:${p=>p.active ? 1 : 0};
  padding:${p=>p.active ? "0 26px 22px" : "0 26px"};
  transition: all .35s ease;
  overflow: hidden;

  p {
    margin: 0 0 10px;
    color: #4a5a6a;
    line-height: 1.7;
    font-size: 16px;     
  }

  ul {
    margin: 0;
    padding-left: 20px;
    color: #4a5a6a;
    font-size: 16px;
    line-height: 1.7;
  }

  li {
    margin-bottom: 6px;
  }

  @media (max-width: 768px) {
    padding: ${p=>p.active ? "0 12px 10px" : "0 16px"};

    p, ul {
      font-size: 12px;
    }
  }
`;

const HeadingFAQ = styled.p`
  font-size: 24px;
  text-align: center;
  padding-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 14px;
    padding-bottom: 2px;
}
`;